module.exports = __webpack_public_path__ + "static/media/virg.fed427db.jpeg";